import React, { useEffect } from 'react';
import CompanyDetail from './CompanyDetail';
import NonMemberDetail from './NonMemberDetail';
import { BusinessTypeEnum, RoleEnum } from '../../types';
import { useCompanyStore } from '../../store/companyStore';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const CompanyDetailWrapper: React.FC = () => {  
  // Use Zustand store
  const { company, fetchMyCompany, clearError } = useCompanyStore();
  const { role } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!role || ![RoleEnum.COMPANY_ADMIN, RoleEnum.HEAD_OFFICE_USER].includes(role)) {
      navigate("/404", { replace: true });
    }
    // Clear previous data when component mounts or id changes
    clearError();
    // Fetch company data
    fetchMyCompany();
  }, []);

  // Check business_type and render appropriate component
  if (company?.business_type === BusinessTypeEnum.NON_MEMBER || company?.business_type === 'NON_MEMBER') {
    return <NonMemberDetail />;
  }

  // Default to CompanyDetail for members and any other cases
  return <CompanyDetail />;
};

export default CompanyDetailWrapper;
